import moment from 'moment';

const Time = () => {
  const isOnAir = (startTime, stopTime) => {
    const startTimeObj = moment(startTime, 'YYYYMMDDHHmmss');
    const now = moment();
    const stopTimeObj = moment(stopTime, 'YYYYMMDDHHmmss');

    return startTimeObj <= now && stopTimeObj >= now;    
  }
  const getToday = (format='YYYY-MM-DD') => {
    return moment().format(format);
  }
  const getCurrentTime = (format='HH:mm:ss') => {
    return moment().format(format);
  }
  const getPrevMonth = (format='YYYY-MM-DD') => {
    const toDay = moment(this.getToday);
    const prevMonthObj = toDay.add(-1, 'month');
    const prevMonth = prevMonthObj.format('YYYY-MM-DD');
    return prevMonth; 
  }
  const getAddDate = (date, day) => {
    const emptyDate = moment(date);
    const addEmptyDate = emptyDate.add(day, 'day');
    const addDate = addEmptyDate.format('YYYY-MM-DD');
    return addDate;
  }
  const getTime = (date) => {
    const dateTimeStr = moment(date).format("hh:mm:ss");
    return dateTimeStr;
  }
  const getDiffDay = (startDate, endDate) => {
    const firstDate = moment(startDate);
    const secondDate = moment(endDate);
    const result = secondDate.diff(firstDate, "days");
    return result;
  }
  const getDiffTime = (startTime, endTime) => {
    const result = parseInt(startTime,10) - parseInt(endTime, 10);
    return Math.abs(result);
  }
  return {
    isOnAir,
    getToday,
    getCurrentTime,
    getPrevMonth,
    getAddDate,
    getTime,
    getDiffDay,
    getDiffTime
  }
};

export default Time();


// WEBPACK FOOTER //
// ./src/util/Time.js